module.exports = __webpack_public_path__ + "img/alxq8.4d00d03b.png";